import { render, staticRenderFns } from "./fiche-formation.vue?vue&type=template&id=65721b7e&scoped=true&"
import script from "./fiche-formation.vue?vue&type=script&lang=js&"
export * from "./fiche-formation.vue?vue&type=script&lang=js&"
import style0 from "./fiche-formation.vue?vue&type=style&index=0&id=65721b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65721b7e",
  null
  
)

export default component.exports